import { Container, Grid, Paper, Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { CreateBase, DateInput, required, SaveButton, SimpleForm, TextInput, Toolbar, useNotify, useRedirect, useTranslate } from 'react-admin';
import { ItemsTable } from '../logic/ItemsTable';
import { supplierServices } from 'src/services/reservation/supplier/supplier.service';
import { supplierPaymentOrderServices } from 'src/services/purchases/supplierPaymentOrder/SupplierPaymentOrder.service';
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput';
import { SelectInput } from 'src/components/uiElements/fields/SelectInput';
import { currencyServices } from 'src/services/reservation/currency/currency.service';
import { useFormContext } from 'react-hook-form';

const CustomSaveButton = () =>{
    const [isDisabled, setIsDisabled] = useState(false)
    const { getValues} = useFormContext();
    const values = getValues()
    useEffect(()=>{
        if(!values['supplier_id'] || !values['due_date']){
            setIsDisabled(true)
            return
        }
        setIsDisabled(false)
    },[values])
    
    return (
        <SaveButton disabled={isDisabled}/>
    )
}

export const SupplierPaymentOrderCreate = (props) => {
    const translate = useTranslate()
    const notify = useNotify()
    const redirect = useRedirect()
    const [supplierId, setSupplierId] = useState(null)
    const [selectedItems, setSelectedItems] = useState([])
    const [supplierLoading, setSupplierLoading] = useState(false)
    const [supplierOptions, setSupplierOptions] = useState([])
    const [currencyId, setCurrencyId] = useState(null)
    const [loadingCurrencyList, setLoadingCurrencyList] = useState(false)
    const [currencyList, setCurrencyList] = useState([])

    useEffect(() => {
        getCurrencies()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getCurrencies = async () => {
        try {
            setLoadingCurrencyList(true)
            const allCurrencies = await currencyServices.getByAll()
            setCurrencyList(allCurrencies)
            setLoadingCurrencyList(false)
        } catch (error) {
            setCurrencyList([])
            setLoadingCurrencyList(false)
        }
    }

    let searchTimeoutCountry
    const getSupplier = async (name) => {
        clearTimeout(searchTimeoutCountry)
        let params = {}
        if(Number.isNaN(Number(name))){
            params.name = name
        } else {
            params.id = Number(name)
        }
        searchTimeoutCountry = setTimeout(async () => {
            try {
                setSupplierLoading(true)
                const allCountries = await supplierServices.getByParam(params)
                setSupplierOptions(allCountries)
                setSupplierLoading(false)
            } catch (error) {
                setSupplierOptions([])
                setSupplierLoading(false)
            }
        }, 700)
    }

    const customSave = async (data) => {
        try{
            const completeData = {...data,
                supplier_id:supplierId,
                currency_id: currencyId,
                items_information:selectedItems.map(item=>{return {
                    item_id:item.item_id,
                    amount:item.amount_pending,
                    pax_id:item.pax_id ?? null,
                }})}
            await supplierPaymentOrderServices.createPaymentOrder(completeData)
            redirect('/supplier-payment-order')
            notify('ra.notification.order_generated_success',{type:'success'})
        }catch{
            notify('ra.notification.order_generated_error',{type:'error'})
        }
    };
  return (
    <Container className='content'>
        <Paper className='paper_content'>
          <CreateBase 
            resource="supplier-payment-order"
            title='Create Supplier Payment Order' {...props}>
            <SimpleForm onSubmit={customSave} toolbar={
                <Toolbar>
                    <CustomSaveButton/>
                </Toolbar>}>
                <div>
                <Grid container>
                    <Grid item lg={12} sm={12} padding={'10px'}>
                        <AutocompleteInput
                            /* useOptionValue = {true} */
                            showLabel
                            label={translate('ra.field.supplier')}
                            fullWidth
                            source='supplier_id'
                            onChange={(e)=>{
                                const value = e.target.value
                                setSupplierId(value?.id);
                                setCurrencyId(value?.currency_relation?.id ?? null)
                            }}
                            options={supplierOptions}
                            loading={supplierLoading}
                            optionsText={['id','name']}
                            onSearch={getSupplier}
                            resetOnLoad={false}
                        />
                    </Grid>
                    <Grid item lg={12} sm={12} padding={'10px'}>
                        {loadingCurrencyList ? (
                            <Skeleton variant='rectangular' width={'100%'} height={40} />
                        ) : (
                            <SelectInput
                                size='small'
                                fullWidth
                                label={translate('ra.field.currency')}
                                source='currency_id'
                                options={currencyList}
                                optionsText={['long_name']}
                                getOptionLabel={item => (
                                    `${item.symbol} ${item.long_name} (${item.short_name})`
                                )}
                                validate={[required()]}
                                defaultValue={currencyId}
                                onChange={(e) => setCurrencyId(e?.target?.value ?? null)}
                            />
                        )}
                    </Grid>
                    <Grid item lg={12} sm={12} padding={'10px'}>
                        <TextInput
                            source='observations'
                            fullWidth
                            label={translate('ra.field.observations')}
                        />
                    </Grid>
                    <Grid item lg={12} sm={12} padding={'10px'}>
                            <DateInput
                                source='due_date'
                                fullWidth
                                required
                                label={translate('ra.field.due_date')}
                            />
                        
                    </Grid>
                </Grid>
                {supplierId && <ItemsTable
                    isPaymentOrder={true}
                    title={translate('ra.title.item_total')}
                    supplierId={supplierId}
                    currencyId={currencyId}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}/>
                }
                </div>
            </SimpleForm>
          </CreateBase>
        </Paper>
      </Container>
  )
}
